<div class="consulta-reentregas container-fluid">
  <h3>Consulta das Gerações de Reentregas</h3>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <form class="d-flex align-items-center filtros-header" [formGroup]="filterForm">
          <mat-form-field>
            <mat-label>Buscar pelo período de:</mat-label>
            <input matInput autocomplete="off" maskDate [matDatepicker]="dataInicio" formControlName="dataInicio">
            <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
            <mat-datepicker #dataInicio></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>até:</mat-label>
            <input matInput autocomplete="off" maskDate [matDatepicker]="dataFim" formControlName="dataFim">
            <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
            <mat-datepicker #dataFim></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-select formControlName="clienteSelecionado" disableOptionCentering="true" placeholder="Cliente:">
                      <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
        noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option *ngFor="let cliente of filteredClientes | async" [value]="cliente?.id">
                {{ cliente?.nome }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>NRT Original:</mat-label>
            <input matInput placeholder="NRT Original" formControlName="nrtOriginal" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>NRT Reentrega:</mat-label>
            <input matInput placeholder="NRT Reentrega" formControlName="nrtReentrega" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Documento:</mat-label>
            <input matInput placeholder="Documento" formControlName="documento" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Status:</mat-label>
            <mat-select formControlName="status">
              <mat-option selected [value]="null">Todos</mat-option>
              <mat-option *ngFor="let status of comboStatus" [value]="status.id">
                {{status.descricao}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Nome do arquivo:</mat-label>
            <input matInput placeholder="Nome do Arquivo" formControlName="arquivo" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Rotina:</mat-label>
            <mat-select formControlName="rotina">
              <mat-option selected [value]="null">Todos</mat-option>
              <mat-option *ngFor="let rotina of comboRotinaSelect" [value]="rotina.id">
                {{rotina.descricao}}
              </mat-option>
            </mat-select>
          </mat-form-field>

            <button mat-icon-button (click)="paging.index = 0; clearFields()" matTooltip="Limpar Campos">
              <i class="fas fa-eraser eraser-button"></i>
            </button>

          <button mat-icon-button (click)="paging.index = 0; getReentregas(true)" [disabled]="filterForm.invalid">
            <i class="fas fa-search search-button cursor-pointer-icon" matTooltip="Pesquisar"></i>
          </button>

        </form>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar [hidden]="!isLoading" color="primary" mode="indeterminate"></mat-progress-bar>
    <mat-card-content class="no-padding" [hidden]="!exibirGrid">
      <div [hidden]="isLoading || consultaGridReentrega?.data?.length === 0">
        <div>
          <table mat-table [dataSource]="consultaGridReentrega">
            <ng-container matColumnDef="dataAlteracao">
              <th mat-header-cell *matHeaderCellDef> Data Alteração </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.dataAlteracao | date: 'dd/MM/yyyy' }} </td>
            </ng-container>

            <ng-container matColumnDef="nrtOriginal">
              <th mat-header-cell *matHeaderCellDef> NRT Original </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.nrtOriginal }} </td>
            </ng-container>

            <ng-container matColumnDef="nrtReentrega">
              <th mat-header-cell *matHeaderCellDef> NRT Reentrega </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.nrtReentrega }} </td>
            </ng-container>

            <ng-container matColumnDef="documento">
              <th mat-header-cell *matHeaderCellDef> Documento </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.documento }} </td>
            </ng-container>

            <ng-container matColumnDef="dtRecep">
              <th mat-header-cell *matHeaderCellDef> Data Recepção </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.dtRecep | date: 'dd/MM/yyyy' }} </td>
            </ng-container>

            <ng-container matColumnDef="cliente">
              <th mat-header-cell *matHeaderCellDef> Cliente </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.cliente }} </td>
            </ng-container>

            <ng-container matColumnDef="destinatario">
              <th mat-header-cell *matHeaderCellDef> Destinatário </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.destinatario }} </td>
            </ng-container>

            <ng-container matColumnDef="endereco">
              <th mat-header-cell *matHeaderCellDef> Endereço </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.endereco }} </td>
            </ng-container>

            <ng-container matColumnDef="bairro">
              <th mat-header-cell *matHeaderCellDef> Bairro </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.bairro }} </td>
            </ng-container>

            <ng-container matColumnDef="cidade">
              <th mat-header-cell *matHeaderCellDef> Cidade </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.cidade }} </td>
            </ng-container>

            <ng-container matColumnDef="uf">
              <th mat-header-cell *matHeaderCellDef> UF </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.uf }} </td>
            </ng-container>

            <ng-container matColumnDef="cep">
              <th mat-header-cell *matHeaderCellDef> CEP </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.cep }} </td>
            </ng-container>

            <ng-container matColumnDef="rotina">
              <th mat-header-cell *matHeaderCellDef> Rotina </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.rotina }} </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.status }} </td>
            </ng-container>

            <ng-container matColumnDef="dataStatus">
              <th mat-header-cell *matHeaderCellDef> Data Status </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.dataStatus | date: 'dd/MM/yyyy' }} </td>
            </ng-container>

            <ng-container matColumnDef="origem">
              <th mat-header-cell *matHeaderCellDef> Origem </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.origem }} </td>
            </ng-container>

            <ng-container matColumnDef="arquivo">
              <th mat-header-cell *matHeaderCellDef> Arquivo </th>
              <td mat-cell *matCellDef="let consultaGridReentrega">
                {{ consultaGridReentrega?.arquivo }} </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <app-paginacao [pageIndex]="paging?.index" [pageSize]="paging?.size" [length]="paging?.length"
          (page)="onPageChange($event)" [pageSizeOptions]="[10, 20, 50]"></app-paginacao>
          <div class="d-flex flex-column justify-content-end align-items-end pr-2 pt-2">
          <button mat-flat-button type="button" color="success" (click)="downloadExcel()"
            [disabled]="isLoadingDownload">
            <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
              <mat-spinner diameter="20" color="dark"></mat-spinner>
              &nbsp; Baixando
            </span>
            <span *ngIf="!isLoadingDownload">
              <i class="fas fa-file-excel"></i> Download Excel
            </span>
          </button>
        </div>
      </div>
      <div *ngIf="!isLoading && consultaGridReentrega?.data?.length === 0"
        class="d-flex justify-content-center align-items-center" style="height: 100px;">
        Nenhum registro para o período!
      </div>
    </mat-card-content>
  </mat-card>
</div>
